module.exports = __webpack_public_path__ + "static/media/insta-section-bg.77a5938f.png";